import React from 'react';
import GeneralAutocompleteFilter, { ConcreteAutocompleteFilterProps } from "./GeneralAutocompleteFilter";

const MediumKindsFilter: React.FC<ConcreteAutocompleteFilterProps> = props => {
    return (
        <GeneralAutocompleteFilter
            multiple
            name={ props.name || 'mediumKindIds' }
            label={ props.label || 'Rodzaje' }
            onFilterChange={ props.onFilterChange }
            options={ props.options }
            values={ props.values }
        />
    );
}
export default MediumKindsFilter;